import { cn } from '@/lib/utils/tw-merge';
import { portableTextComponents } from '@/lib/sanity/portable-text';
import { PortableText } from '@portabletext/react';
import type { ComponentProps } from 'react';

type PTProps = ComponentProps<typeof PortableText>;

type RestProps = PTProps & {
    className?: string;
};

export function PortableTextRenderer({ className, components, ...props }: RestProps) {
    return (
        <div className={cn('prose', className)}>
            <PortableText {...props} components={components ?? portableTextComponents} />
        </div>
    );
}
